import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconVideo = ({ id, color, width = 20, style, ...restProps }: IProps) => {
  const viewBoxWidth = 20;
  const viewBoxHeight = 20;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18.4c-4.6 0-8.4-3.7-8.4-8.4 0-4.6 3.7-8.4 8.4-8.4 4.6 0 8.4 3.7 8.4 8.4 0 4.6-3.8 8.4-8.4 8.4z"
      />
      <path
        fill={iconColor}
        d="M8.1 4.9c-.1-.1-.2-.1-.4-.1-.5 0-.8.4-.8.8v8.8c0 .5.4.8.8.8.2 0 .3 0 .5-.1l6.5-4.4c.1-.1.2-.1.2-.2.3-.4.2-.9-.2-1.1L8.1 4.9zm.4 8V7.1l4.2 2.9-4.2 2.9z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconVideo;
